import React from "react";
import { Link } from "react-router-dom";

const Introduction = () => (
  <div>
    <h2>1. Introduction</h2>
    <p>
      The Portal Admin site allows administrators to: add new users; view and edit existing users on
      the site; check and run reports on user progress and scores; as well as allowing for certain
      aspects of the site to be customised.
    </p>
    <p>The web address to access the admin site is as follows:</p>
    <p>
      <Link to={"/"}>{`https://${process.env.HOST}`}</Link>
    </p>
  </div>
);

export default Introduction;
